var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boy_warp"},[_c('p',[_vm._v("适龄劳动人口数占比")]),_c('div',{ref:"echartsINof",staticStyle:{"height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }